$(document).ready(function() {
    // Remove 'email' parameter from URL if exists
    const url = new URL(window.location.href);
    if (url.searchParams.has('email')) {
        url.searchParams.delete('email');
        window.history.replaceState({}, '', url);
    }

    // Set email input value from cookie if exists
    const lastEmail = document.cookie.split('; ').find(row => row.startsWith('last_email='));
    if (lastEmail) {
        $('#email').val(lastEmail.split('=')[1]);
    }

    const form = $('#formAuthentication');

    // Form validation
    form.on('submit', function(e) {

        let isValid = true;
        const errorMessages = {
            email: 'Please enter a valid email address',
            password: 'Password is required'
        };
        
        // Clear previous error messages
        $('.error-message').remove();
        $('.is-invalid').removeClass('is-invalid');
        
        // Validate email
        const email = $('#email').val().trim();
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
            $('#email').addClass('is-invalid');
            $('#email').after('<div class="error-message text-danger">' + errorMessages.email + '</div>');
            isValid = false;
        }
        
        // Validate password
        const password = $('#password').val();
        if (password.length === 0) {
            $('#password').addClass('is-invalid');
            $('#password').closest('.form-password-toggle').append('<div class="error-message text-danger">' + errorMessages.password + '</div>');
            isValid = false;
        }
        
        // If form is valid, submit via AJAX
        if (!isValid) {
           e.preventDefault();
        }

        // Set cookie with email for 30 days
        const d = new Date();
        d.setTime(d.getTime() + (30 * 24 * 60 * 60 * 1000));
        document.cookie = "last_email=" + email + ";expires=" + d.toUTCString() + ";path=/";

    });
    
    // Toggle password visibility
    $('.input-group-text').on('click', function() {
        const passwordInput = $(this).siblings('input');
        const icon = $(this).find('i');
        
        if (passwordInput.attr('type') === 'password') {
            passwordInput.attr('type', 'text');
            icon.removeClass('bx-hide').addClass('bx-show');
        } else {
            passwordInput.attr('type', 'password');
            icon.removeClass('bx-show').addClass('bx-hide');
        }
    });
    
    
    
});